export const ARENA_RECOVERY_LABELS = Object.freeze({
    'Обычный': '1 ч',
    'Редкий': '1 ч 30 м',
    'Эпический': '2 ч',
    'Легендарный': '3 ч',
    'Мифический': '4 ч',
});

export function recoveryRemaining(cardId, recovery = {}, nowSec = Date.now() / 1000) {
    const raw = Number(recovery?.[String(cardId)] || 0);
    // The API returns remaining seconds. Accept timestamps too for cache-safe UI.
    return Math.max(0, Math.ceil(raw > 10_000_000 ? raw - nowSec : raw));
}

export function formatRecovery(seconds) {
    const value = Math.max(0, Math.ceil(Number(seconds) || 0));
    if (!value) return 'Готова';
    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const secs = value % 60;
    if (hours) return `${hours} ч ${String(minutes).padStart(2, '0')} м`;
    if (minutes) return `${minutes} м ${String(secs).padStart(2, '0')} с`;
    return `${secs} с`;
}

export function normalizeArenaDecks(source) {
    const input = Array.isArray(source) ? source : [];
    return ['1', '2', '3'].map(id => {
        const deck = input.find(item => String(item?.id) === id) || {};
        return {
            id,
            name: String(deck.name || `Колода ${id}`).slice(0, 24),
            slots: normalizeArenaSlots(deck.slots),
        };
    });
}

export function normalizeArenaSlots(slots) {
    const source = slots && typeof slots === 'object' ? slots : {};
    const result = {};
    const used = new Set();
    for (let position = 1; position <= 4; position += 1) {
        const cardId = String(source[String(position)] ?? source[position] ?? '').trim();
        if (!cardId || used.has(cardId)) continue;
        result[String(position)] = cardId;
        used.add(cardId);
    }
    return result;
}

export function arenaDeckCardCount(slots) {
    return Object.keys(normalizeArenaSlots(slots)).length;
}

export function isArenaDeckComplete(slots) {
    return arenaDeckCardCount(slots) === 4;
}

export function arenaDeckChanged(savedSlots, draftSlots) {
    return JSON.stringify(normalizeArenaSlots(savedSlots)) !== JSON.stringify(normalizeArenaSlots(draftSlots));
}

export function autoSelectArenaCards(cards, recovery = {}, limit = 4) {
    return [...(Array.isArray(cards) ? cards : [])]
        .filter(card => recoveryRemaining(card?.id, recovery) === 0)
        .sort((a, b) => {
            const scoreA = Number(a?.damage || a?.atk || 0) * 2 + Number(a?.health || a?.hp || 0);
            const scoreB = Number(b?.damage || b?.atk || 0) * 2 + Number(b?.health || b?.hp || 0);
            return scoreB - scoreA;
        })
        .slice(0, limit);
}

export function slotsFromCards(cards) {
    return Object.fromEntries((cards || []).slice(0, 4).map((card, index) => [String(index + 1), String(card.id)]));
}
